import React, { Component } from 'react';
import { Trans } from "react-i18next";
import { NavLink } from 'react-router-dom';
import axios from 'axios';
import SideBar from "./SideBar";
import SideNav from "react-simple-sidenav";
import "../../config/i18n";
import { withTranslation } from "react-i18next"; 
import {CopyToClipboard} from 'react-copy-to-clipboard';

import ls from "local-storage"; 
import { options } from "../../config/options";

import { SmartToaster, toast } from 'react-smart-toaster';
class Promotinaloffer extends Component{

    constructor(props) {
        super(props);
        this.loggedIn = sessionStorage.getItem('loggedin');

        this.state = {
            credits:'0',
             api_url:localStorage.getItem('api_url'),
             showNav3: false,user_details:'',
               offers:[],
              lang: ls.get('LangKeySet') || options[0],
            langKey: ls.get('LangValue'),
            nodata:false,
            clas1:'',clas2:'',clas3:'',clas4:'',clas5:'',txt1:'',txt2:'', 
            currency_code:"",

            value: '',
            copied: false,

        }
        
    }

    addDefaultSrc(ev){
        ev.target.src =  require('../../assets/img/howzu-logo-default.png')
      }


    componentDidMount(){

        var datalist = new FormData();   
        datalist.set('user_id', JSON.parse(localStorage.getItem('session_userid'))); 
        datalist.set('language', this.state.langKey); 
        datalist.set('limit', 300); 
        datalist.set('offset', 0);    
        axios({
            method: 'post',
            url: this.state.api_url+'getcoupons',
            data: datalist,    
            config: { headers: {'Content-Type': 'multipart/form-data',
            'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
             }}

        }).then(res=>{

            if(res.data.status === 'true') {
               
                this.setState({
                    offers:[...res.data.coupons]
                 });
                
            }
            else{

                this.setState({ 
                    nodata:true, clas1: 'noItemsContainers',clas2:'visitorsNull',clas3:'nullVisitors nullSize',clas4:'text-dark bold-font text-center apk-20',clas5:'secondaryText apk-16 regular-font text-center',txt1:'No Visitors',txt2:'Update the Filters!' }
                    );

            }

            // console.log("offers"+JSON.stringify(this.state.offers));
            
        }).catch(error => {
            // this.props.history.push("/login"); 
         });
    }

    render(){
       
        return(
            <div className="setting-page">


<div className="d-flex profile-header-top stickyProfileHead justify-content-between apd15 apr0 apl0 white-bg ">
                    <div class="heading-left-top d-flex">
                        <div className="align-self-center ">
                            <div className="iconHolder align-self-center mr-1">
                                <div className="backGlow  d-block d-lg-none">
                                {/* <div className="backIco" onClick={() => this.setState({ showNav3: true })}></div> */}

                                <NavLink to={"/app/wallet"} >
                                
                                    <div className="backIco"></div>
                              
                                </NavLink>
                                </div>
                                <NavLink to={"/app/wallet"} >
                                 <div className="backGlow  d-block nonResp">
                                    <div className="backIco"></div>
                                </div>
                                </NavLink>
                            </div>
                        </div>
                        <span className="arrow-center align-self-center ml-1 bold-font"><Trans i18nKey="Scratch Card & Coupon">Scratch Card & Coupon</Trans></span>
                    </div>
                    <div className="backGlow white-bg"></div>
                </div>  

                <div className="settingsPageWidth">


                 {
                    
                     this.state.nodata===false ?
                        
                    <div>
                       
                        {this.state.offers.map((data, index) =>

                      
                            <div key={index}>
                              
                           <div  className={`coupon-card ${data.status}`}>
                           
                           <CopyToClipboard text={data.offer_code}
                                  onCopy={() => this.setState({copied: true})}>
                                     <button onClick={ () => toast.success(<Trans i18nKey="Coupon code copied">Coupon code copied</Trans>)} style={{display: data.status == 'Active' ? 'block' : 'none'}} type="button" class=""></button>	
                           </CopyToClipboard>

                           {/* {this.state.copied ? <span style={{color: 'red'}}>Copied.</span> : null} */}

                           <SmartToaster 
    store={toast} 
    lightBackground={true} 
    position={"top_right"}
/>


                         <span class="ribbon"><span>{data.status == 'Used'? <Trans i18nKey="Scratch">Scratch</Trans> : <Trans i18nKey={data.status+' '}>{data.status+" "}</Trans>}</span></span>	                       
		              <div class="price bold-font" >{data.currency} <span>{data.price}</span></div>
		               <div class=" mb-3"  id='couponcode'><Trans i18nKey="Code">Code</Trans>: <span>{data.offer_code}</span></div>
		               <div class="valid bold-font"><Trans i18nKey="Valid only On">Valid only On</Trans> {data.expiry_date}</div>
                         </div>
                        </div>
                        )}
                     </div> 

                         :
                         <div className={this.state.clas1}>

                        <div class={this.state.clas2}>
                            <div className={this.state.clas3}></div>
                            <div className={this.state.clas4}><Trans i18nKey="No Promotional offers">No Promotional offers</Trans></div>  
                        </div>                     
                     </div>
                 }
               

   
                 </div> 

                 <div className="sidebarResp d-block d-lg-none">
                    <SideNav showNav={this.state.showNav3} onHideNav={() => this.setState({ showNav3: false })} title={<div></div>} items={[<SideBar />]} />
                </div>
               
                </div>



        )
    }
}

export default withTranslation("translations")(Promotinaloffer);